<template>
  <el-dialog 
    :model-value="visible" 
    @close="$emit('close')"
    width="400px"
    :close-on-click-modal="false"
    append-to-body
    dialog-class="custom-dialog-radius">
  <div class="register-container">
    <!-- 标题 -->
    <div class="dialog-title">手机号注册</div>

    <!-- 表单 -->
    <el-form label-position="top" :model="form" ref="formRef">
      <!-- 手机号 -->
      <el-form-item label="手机号">
        <div class="input-box phone-input">
          <span class="country-code">+86</span>
          <el-input v-model="form.phone" placeholder="请输入手机号码" maxlength="11" type="tel"></el-input>
        </div>
      </el-form-item>

      <!-- 验证码 -->
      <el-form-item label="验证码">
        <div class="input-box code-input">
          <span class="code-label">验证码</span>
          <el-input v-model="form.code" placeholder="请输入" maxlength="6"></el-input>
          <el-button type="primary" class="get-code-btn" @click="handleGetVerificationCode" :disabled="countdown > 0">
            <span>{{ countdown > 0 ? `重新发送(${countdown}s)` : '获取验证码' }}</span>
          </el-button>
        </div>
      </el-form-item>

      <!-- 邀请码 -->
      <el-form-item>
        <template #label>
          <span>邀请码</span>
          <el-tooltip content="填写邀请码可获得额外奖励" placement="top">
            <el-icon style="margin-left: 5px;"><QuestionFilled /></el-icon>
          </el-tooltip>
        </template>
        <el-input 
          v-model="form.inviteCode" 
          type="textarea" 
          :rows="2"
          placeholder="如有邀请码，请在此填写（选填）"
          class="invite-code-input"
        ></el-input>
      </el-form-item>

      <!-- 邮箱 -->
      <el-form-item>
        <template #label>
          <span>邮箱</span>
          <el-tooltip content="填写邮箱，以便我们将最新的优惠活动通知您" placement="top">
            <el-icon style="margin-left: 5px;"><QuestionFilled /></el-icon>
          </el-tooltip>
        </template>
        <el-input v-model="form.email" placeholder="请输入您的邮箱（非必填）"></el-input>
      </el-form-item>
      
      <!-- 用户协议 -->
      <el-form-item>
        <el-checkbox v-model="form.agreeTerms">
          我已阅读并同意
          <a href="#" class="agreement-link" @click.prevent="goToUserAgreement">《用户协议》</a>
        </el-checkbox>
      </el-form-item>
      
      <!-- 注册按钮 -->
      <div class="button-container">
        <el-button
          type="primary"
          class="register-btn"
          @click="handleRegister"
        >
          <span>注册</span>
        </el-button>
      </div>
    </el-form>

  </div>
  </el-dialog>
</template>

<script>
import {register, code} from "../api/login/register";
export default {
  name: 'UserRegister',
  data() {
    return {
      form: {
        phone: '', // 手机号
        scene: 'register', // 场景
        code: '', // 验证码
        inviteCode: '', // 邀请码
        email: '', // 邮箱
        agreeTerms: false, // 是否同意用户协议
      },
      countdown: 0, // 倒计时
    };
  },
  props: {
    visible: Boolean
  },
  methods: {
    // 获取验证码
    async handleGetVerificationCode() {
      console.log('发送验证码1...');
      if (this.countdown > 0) return;
       // 准备登录信息
      const obj = Object.assign({}, this.form);
      obj.scene = 'register';
      code(obj).then(response => {
          if (response.code === 200) {
            this.$notify({ title: '成功', message: '验证码已发送', type: 'success', duration: 2000 });
            // 启动倒计时
            this.countdown = 60;
            const timer = setInterval(() => {
              if (this.countdown <= 0) {
                clearInterval(timer);
              } else {
                this.countdown--;
              }
            }, 1000);
          } else {
            this.$alert(response.message, '提示', { type: 'warning' });
          }
        }).catch(error => {
          console.error(error)
        })
    },

    // 重新发送验证码
    handleResendCode() {
      console.log('重新发送验证码...');
    },

    // 跳转用户协议
    goToUserAgreement() {
      window.open(this.$router.resolve({ name: 'home', query: { activeIndex: 2, showUserAgreement: true }}).href, '_blank');
    },

    // 处理注册
    async handleRegister() {
      if (!this.form.agreeTerms) {
        this.$message.error('请先同意用户协议');
        return;
      }
      // 准备注册信息
      const obj = Object.assign({}, this.form);
      const response = await register(obj);
      console.log('response', response);
      if (response.code === 200) {
        this.$notify({
          title: '成功',
          message: '注册成功',
          type: 'success',
          duration: 2000
        });
        this.$emit('registerSuccess', response.data);
        this.$emit('close');
      } else {
        this.$alert(response.message, '提示', { type: 'warning' });
      }
    },
  },
};
</script>

<style scoped>
.register-container {
  padding: 0px 8px 8px 8px;
}

.dialog-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
}

/* 统一输入容器，与 Login.vue 对齐 */
.input-box {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  height: 40px;
  width: 100%;
}
.input-box :deep(.el-input__wrapper) { box-shadow: none !important; }
.input-box :deep(.el-input__inner) { height: 40px; }
.input-box .el-input { flex: 1; }

/* 左侧标签/区号 与 Login.vue 保持一致宽度 */
.country-code,
.code-label {
  box-sizing: border-box;
  width: 76px;
  padding: 0 12px;
  border-right: 1px solid #ddd;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
}
.country-code { color: #333; font-size: 14px; background-color: #fff; }
.code-label { color: #666; font-size: 14px; }

/* 右侧验证码按钮固定宽度，与 Login.vue 对齐 */
.get-code-btn {
  min-width: 110px;
  padding: 0 12px;
  height: 100%;
  background-color: transparent;
  border: none;
  color: #409eff;
  font-size: 13px;
  cursor: pointer;
  border-left: 1px solid #ddd;
  white-space: nowrap;
}
.get-code-btn.is-disabled,
.get-code-btn:disabled { color: #c0c4cc; cursor: not-allowed; }
.get-code-btn:hover:not(.is-disabled) { background-color: #f8f9fa; }

/* 用户协议链接 */
.agreement-link {
  color: #409eff;
  text-decoration: underline;
}

/* 按钮容器 */
.button-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 20px !important;
  position: relative !important;
}

/* 注册按钮 */
.register-btn {
  width: 120px;
  height: 40px;
  border-radius: 8px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  border: none;
}

/* 表单样式 */
:deep(.el-form-item__label) {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #1f2329 !important;
  display: block;
  margin-bottom: 8px;
}
:deep(.el-input__inner) { height: 40px; font-size: 14px; }
:deep(.el-input__inner::placeholder) { font-size: 14px; color: #b8b2b2; }

.el-form-item { margin-bottom: 12px; }

/* 邀请码输入框 - 使用 textarea 支持 placeholder 换行 */
.invite-code-input :deep(.el-textarea__inner) {
  min-height: 40px;
  height: auto;
  line-height: 1.5;
  resize: none;
  padding: 10px 12px;
  font-size: 14px;
}

.invite-code-input :deep(.el-textarea__inner::placeholder) {
  font-size: 14px;
  color: #b8b2b2;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-all;
}
/* 字数统计 */
.input-count { color: #bbb; font-size: 12px; text-align: right; margin-top: 2px; }
/* 问号图标样式 */
.el-icon { color: #999; }

/* 弹窗圆角 */
.custom-dialog-radius .el-dialog__body { border-radius: 10px; }

/* 移动设备适配 */
@media (max-width: 768px) {
  .el-dialog { width: 95vw !important; max-width: 95vw !important; margin: 2.5vw auto !important; }
  .register-container { padding: 20px 16px; }
  .dialog-title { font-size: 1.5rem; margin-bottom: 20px; }
  :deep(.el-form-item__label) { font-size: 13px !important; margin-bottom: 6px; }
  :deep(.el-input__inner) { height: 40px; font-size: 14px; }
  .invite-code-input :deep(.el-textarea__inner) {
    min-height: 40px;
    font-size: 14px;
  }
  .input-tip, .input-count { font-size: 11px; }
  .code-btn { width: 100%; height: 40px; }
  .button-container { display: flex !important; justify-content: center !important; align-items: center !important; margin-top: 20px !important; position: relative !important; }
  .register-btn { width: 100%; height: 44px; font-size: 16px; margin-top: 20px; }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .el-dialog { width: 80vw !important; max-width: 80vw !important; }
  .register-container { padding: 24px 20px; }
  .dialog-title { font-size: 1.6rem; }
  :deep(.el-input__inner) { height: 42px; font-size: 15px; }
  .button-container { display: flex !important; justify-content: center !important; align-items: center !important; margin-top: 20px !important; position: relative !important; }
  .register-btn { width: 140px; height: 42px; font-size: 15px; }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .el-dialog { width: 98vw !important; max-width: 98vw !important; margin: 1vw auto !important; }
  .register-container { padding: 16px 12px; }
  .dialog-title { font-size: 1.3rem; margin-bottom: 16px; }
  :deep(.el-form-item__label) { font-size: 12px !important; margin-bottom: 4px; }
  :deep(.el-input__inner) { height: 38px; font-size: 13px; }
  .invite-code-input :deep(.el-textarea__inner) {
    min-height: 38px;
    font-size: 13px;
  }
  .input-tip, .input-count { font-size: 10px; }
  .button-container { display: flex !important; justify-content: center !important; align-items: center !important; margin-top: 16px !important; position: relative !important; }
  .register-btn { height: 40px; font-size: 15px; margin-top: 16px; }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .el-dialog { width: 90vw !important; max-width: 90vw !important; max-height: 90vh !important; overflow-y: auto; }
  .register-container { padding: 20px 16px; }
  .button-container { display: flex !important; justify-content: center !important; align-items: center !important; margin-top: 20px !important; position: relative !important; }
  .register-btn { width: 120px; height: 38px; font-size: 14px; }
}
</style>